import React, { useState } from "react";
import {
  TextField,
  Button,
  Typography,
  Box,
  Grid,
  Snackbar,
  InputAdornment,
  Checkbox,
  FormControlLabel
} from "@mui/material";
import { Email, Lock } from "@mui/icons-material";
import AuthController from "../Controllers/AuthController";
import { useNavigate } from "react-router-dom";

const Auth = () => {

  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [openSnackbar, setOpenSnackbar] = useState(false);
  const [feedbackMessage, setFeedbackMessage] = useState("");
  const [errorMessage, setErrorMessage] = useState("");

  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {

      const loginResponse = await AuthController.handleLogin(email, password);

      setFeedbackMessage("Login successful");
      setOpenSnackbar(true);

      navigate(loginResponse.isVerified ? "/resto" : "/resto");

    } catch (error) {

      setErrorMessage(`Error: ${error.message}`);
      setOpenSnackbar(true);

    }
  };
   const handleForgotPassword = () => {
    navigate("/ForgetPassword");
  };


  return (

    <Grid
      container
      sx={{
        minHeight: "100vh",
        background: "#f3f4f6"
      }}
    >

      {/* LEFT SIDE */}

      <Grid
        item
        md={6}
        sx={{
          display: { xs: "none", md: "flex" },
          flexDirection: "column",
          justifyContent: "center",
          pl: 10
        }}
      >

        <Box>

          <Typography
            variant="h5"
            sx={{ fontWeight: 700, mb: 3 }}
          >
            Restaurant ERP
          </Typography>

          <Typography
            variant="h3"
            sx={{
              fontWeight: "bold",
              mb: 3,
              lineHeight: 1.2
            }}
          >
            Bienvenue sur votre plateforme
            de gestion
          </Typography>

          <Typography
            sx={{
              color: "#6b7280",
              mb: 4,
              maxWidth: 450
            }}
          >
            Gérez votre restaurant avec efficacité et simplicité.
            Tout ce dont vous avez besoin en un seul endroit.
          </Typography>

          <Box sx={{ mb: 2 }}>
            <Typography sx={{ fontWeight: 600 }}>
              • Gestion Complète
            </Typography>
            <Typography sx={{ color: "#6b7280" }}>
              Stocks, employés, finances – tout en un
            </Typography>
          </Box>

          <Box sx={{ mb: 2 }}>
            <Typography sx={{ fontWeight: 600 }}>
              • Analyses en Temps Réel
            </Typography>
            <Typography sx={{ color: "#6b7280" }}>
              Suivez vos performances instantanément
            </Typography>
          </Box>

          <Box>
            <Typography sx={{ fontWeight: 600 }}>
              • Sécurisé & Fiable
            </Typography>
            <Typography sx={{ color: "#6b7280" }}>
              Vos données sont protégées
            </Typography>
          </Box>

        </Box>

      </Grid>

      {/* RIGHT SIDE LOGIN */}

      <Grid
        item
        xs={12}
        md={6}
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center"
        }}
      >

        <Box
          sx={{
            width: 420,
            background: "white",
            borderRadius: "16px",
            p: 4,
            boxShadow: "0 10px 30px rgba(0,0,0,0.08)"
          }}
        >

          <Typography
            variant="h4"
            sx={{ fontWeight: 700, mb: 1 }}
          >
            Connexion
          </Typography>

          <Typography
            sx={{ color: "#6b7280", mb: 3 }}
          >
            Connectez-vous à votre compte
          </Typography>

          <Box component="form" onSubmit={handleSubmit}>

            <TextField
              fullWidth
              label="Adresse Email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              sx={{ mb: 3 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Email />
                  </InputAdornment>
                ),
                sx: { borderRadius: "10px" }
              }}
            />

            <TextField
              fullWidth
              label="Mot de Passe"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              sx={{ mb: 2 }}
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <Lock />
                  </InputAdornment>
                ),
                sx: { borderRadius: "10px" }
              }}
            />

            <Box
              sx={{
                display: "flex",
                justifyContent: "space-between",
                mb: 3
              }}
            >

              <FormControlLabel
                control={<Checkbox />}
                label="Se souvenir de moi"
              />

               <Typography
                onClick={handleForgotPassword}
                sx={{
                  color: "#2563eb",
                  cursor: "pointer",
                  fontSize: 14,
                  fontWeight: 500,
                  '&:hover': {
                    textDecoration: "underline"
                  }
                }}
              >
                Mot de passe oublié?
              </Typography>
         


            </Box>

            <Button
              fullWidth
              type="submit"
              variant="contained"
              sx={{
                background:
                  "linear-gradient(90deg,#2563eb,#9333ea)",
                py: 1.4,
                borderRadius: "10px",
                fontWeight: 600
              }}
            >
              Se Connecter →
            </Button>

            

          </Box>

        </Box>

      </Grid>

      <Snackbar
        open={openSnackbar}
        autoHideDuration={6000}
        onClose={() => setOpenSnackbar(false)}
        message={feedbackMessage || errorMessage}
      />

    </Grid>
  );
};

export default Auth;